<template>
  <div class="pdl-card mb-2" :class="{'pdl-card--padded': isPadded}">
    <div v-if="hasHeaderSlot" class="pdl-card__header">
      <!-- @slot Slot for header content. -->
      <slot name="header" />
    </div>
    <div v-if="hasImageSlot" class="pdl-card__img" :class="{'pdl-card__img--padded': hasPaddedImage}">
      <!-- @slot Slot for an image. -->
      <slot name="image" />
    </div>

    <div class="pdl-card__body">
      <div v-if="hasMetaContentSlot" class="pdl-card__meta flex text-xs font-medium leading-tight mb-1">
        <!-- @slot Slot for meta content. -->
        <slot name="metaContent" />
      </div>
      <!-- @slot Slot for a body content. -->
      <slot name="bodyContent" />
    </div>
    <template v-if="hasFooterSlot">
      <div class="grow"></div>
      <div class="pdl-card__footer">
        <!-- @slot Slot for a button or link. -->
        <slot name="footer" />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'PdlCard',
  props: {
    /**
     * Provides padding and a border.
     */
    isPadded: {
      type: Boolean,
      default: false,
    },
    /**
     * Provides padding to the image.
     */
    hasPaddedImage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasHeaderSlot() {
      return !!this.$slots.header;
    },
    hasImageSlot() {
      return !!this.$slots.image;
    },
    hasMetaContentSlot() {
      return !!this.$slots.metaContent;
    },
    hasFooterSlot() {
      return !!this.$slots.footer;
    },
  },
};
</script>

<style lang="scss">
@import 'Card.scss';
</style>
